import ApiService from '@/services/core/api.service'

const MunicipalityService = {
  async get (query) {
    return ApiService.get(`admin/municipalities?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/municipalities', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/municipalities/${payload.id}`, payload)
  }
}

export default MunicipalityService
